var map = {
	"./pages/jobcard/jobcard.module": [
		"./src/app/pages/jobcard/jobcard.module.ts",
		"pages-jobcard-jobcard-module"
	],
	"./pages/jobcardview/jobcardview.module": [
		"./src/app/pages/jobcardview/jobcardview.module.ts",
		"pages-jobcardview-jobcardview-module"
	],
	"./pages/knowledgecard/knowledgecard.module": [
		"./src/app/pages/knowledgecard/knowledgecard.module.ts",
		"pages-knowledgecard-knowledgecard-module"
	],
	"./pages/login/login.module": [
		"./src/app/pages/login/login.module.ts",
		"pages-login-login-module"
	],
	"./pages/profil/profil.module": [
		"./src/app/pages/profil/profil.module.ts",
		"pages-profil-profil-module"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;